import { tv, type VariantProps } from 'tailwind-variants'

export const message = tv({
  base: 'flex w-full flex-col gap-4 p-4 overflow-visible data-[hover=true]:translate-x-0 data-[hover=true]:translate-y-0',
  variants: {
    colors: {
      primary: 'text-primary-text-contrast-default',
      secondary: 'text-secondary-text-contrast-default',
      success: 'text-success-text-contrast-default',
      danger: 'text-danger-text-contrast-default',
    },
  },
  compoundVariants: [
    {
      colors: 'primary',
      class: 'bg-primary-bg-light data-[hover=true]:bg-primary-bg-medium',
    },
    {
      colors: 'secondary',
      class: 'bg-secondary-bg-light data-[hover=true]:bg-secondary-bg-medium',
    },
    {
      colors: 'success',
      class: 'bg-success-bg-light data-[hover=true]:bg-success-bg-medium',
    },
    {
      colors: 'danger',
      class: 'bg-danger-bg-light data-[hover=true]:bg-danger-bg-medium',
    },
  ],
})

export type TMessageVariantProps = VariantProps<typeof message>
